<template>
    <div>
        <table class="table text-left mb-0">
            <thead>
                <tr>
                    <th style="border-bottom: 0;">
                        <div class="tooltip-container cursor-pointer">
                            <p class="text-[#ff00a7] m-0 flex items-center gap-2">
                              <span>Husk, at du selv fastsætter din pris.</span>
                              <img src="/img/icons/icon_tooltip_influencer.svg" alt="tooltip" width="20"/>
                            </p>
                            <div class="tooltip-card text-base text-white font-normal">
                                <p class="m-0">For at anmode om et job skal du komme med et bud for hvor meget du skal have for at udføre jobbet. Derefter har brandet mulighed for at forhandle en endelig pris med dig, og først når i begge er enige om en endelig pris, at jeres samarbejde officielt starter.</p>
                                <p class="mt-2">Husk at dit bud burde tage udgangspunkt i dine antal følgere og jobbet størelse.</p>
                                <p class="m-0">Minimum pris er 500 DKK for et job</p>
                            </div>
                        </div>
                    </th>
                    <th class="text-right" width="180" style="color: #ff00a7; border-bottom: 0;">
                        Beløb
                    </th>
                </tr>
            </thead>
            <tbody style="color: #065c43">
                <tr class="d-none md:table-row">
                    <td  style="border: 1px solid #045C43; border-right: 0;">
                        {{ campaignName }}
                        <!-- <div class="small">
                          <div class="inline">
                            <PreviewableInput
                                :form="form"
                                field="posts"
                                :can-preview="!alwaysEdit"
                                @preview="changingPrice = false"
                                @edit="changingPrice = true"
                            >
                              <div slot="preview">
                                Opslag: {{ form.posts }}
                              </div>
                              <template v-slot:input="{ inputAttrs, inputEvents }">
                                <FormItem
                                    :form="form"
                                    field="posts"
                                    help-block-label="Kampagnepris"
                                >
                                  <div class="input-group">
                                          <span
                                              class="input-group-addon"
                                              v-text="'Opslag'"
                                          />
                                    <input
                                        class="form-control text-right w-25"
                                        v-bind="inputAttrs"
                                        v-on="inputEvents"
                                    />
                                  </div>
                                </FormItem>
                              </template>
                            </PreviewableInput>
                          </div>
                        </div> -->
                        <div class="small">Virksomhed: {{ brandName }}</div>
                    </td>
                    <td class="text-right" style="border: 1px solid #045C43; border-left: 0;">
                        <PreviewableInput
                            :form="form"
                            field="influencer_cost.amount"
                            :can-preview="!alwaysEdit"
                            :maxlength="11"
                            :max-value="maxPrice"
                            @preview="changingPrice = false"
                            @edit="changingPrice = true"
                        >
                            <div slot="preview">
                                <span v-if="form.influencer_cost.amount === 0">-</span>
                                <div v-else>
                                    <span class="flex-1" v-text="form.influencer_cost.currency"></span>
                                    <span v-text="form.influencer_cost.amount"></span>
                                </div>
                            </div>
                            <template v-slot:input="{ inputAttrs, inputEvents }">
                                <FormItem
                                    :form="form"
                                    field="influencer_cost.amount"
                                    help-block-label="Kampagnepris"
                                >
                                    <div class="input-group">
                                        <span
                                            class="input-group-addon"
                                            v-text="form.influencer_cost.currency"
                                        />
                                        <input
                                            class="form-control text-right"
                                            v-bind="inputAttrs"
                                            v-on="inputEvents"
                                        />
                                    </div>
                                </FormItem>
                            </template>
                        </PreviewableInput>
                      <div v-show="form.errors.has('influencer_cost.amount') && !changingPrice" class="text-[#a94442]" v-text="form.errors.get('influencer_cost.amount')">Error</div>
                    </td>
                </tr>
                 <tr class="table-row md:hidden">
                    <td  style="border: 1px solid #045C43; border-bottom: 0;" colspan="2">
                        {{ campaignName }}
                        <!-- <div class="small">
                          <div class="inline">
                            <PreviewableInput
                                :form="form"
                                field="posts"
                                :can-preview="!alwaysEdit"
                                @preview="changingPrice = false"
                                @edit="changingPrice = true"
                            >
                              <div slot="preview">
                                Opslag: {{ form.posts }}
                              </div>
                              <template v-slot:input="{ inputAttrs, inputEvents }">
                                <FormItem
                                    :form="form"
                                    field="posts"
                                    help-block-label="Kampagnepris"
                                >
                                  <div class="input-group">
                                          <span
                                              class="input-group-addon"
                                              v-text="'Opslag'"
                                          />
                                    <input
                                        class="form-control text-right w-25"
                                        v-bind="inputAttrs"
                                        v-on="inputEvents"
                                    />
                                  </div>
                                </FormItem>
                              </template>
                            </PreviewableInput>
                          </div>
                        </div> -->
                        <div class="small">Virksomhed: {{ brandName }}</div>
                    <!-- </td>
                    <td class="text-right" style="border: 1px solid #045C43; border-left: 0;"> -->
                        <PreviewableInput
                            :form="form"
                            field="influencer_cost.amount"
                            :can-preview="!alwaysEdit"
                            :maxlength="11"
                            :max-value="maxPrice"
                            @preview="changingPrice = false"
                            @edit="changingPrice = true"
                        >
                            <Amount slot="preview" v-model="form.influencer_cost" />
                            <template v-slot:input="{ inputAttrs, inputEvents }">
                                <FormItem
                                    :form="form"
                                    field="influencer_cost.amount"
                                    help-block-label="Kampagnepris"
                                >
                                    <div class="input-group">
                                        <span
                                            class="input-group-addon"
                                            v-text="form.influencer_cost.currency"
                                        />
                                        <input
                                            class="form-control text-right"
                                            v-bind="inputAttrs"
                                            v-on="inputEvents"
                                        />
                                    </div>
                                </FormItem>
                            </template>
                        </PreviewableInput>
                    </td>
                </tr>
                <tr>
                    <th style="border: 1px solid #045C43; border-right: 0;">Din betaling</th>
                    <th class="text-right" style="border: 1px solid #045C43; border-left: 0;">
                        <amount v-model="influencerProfit" />
                    </th>
                </tr>
                <tr>
                    <th style="border: 1px solid #045C43; border-right: 0;">Til udbetaling</th>
                    <th class="text-right" style="border: 1px solid #045C43; border-left: 0;">
                        <amount v-model="influencerPayout" />
                    </th>
                </tr>
            </tbody>
        </table>

        <div class="small text-left mt-2 mb-5" style="color: #065c43;">
            * Angiv din pris inkl. moms
        </div>

        <slot v-if="changingPrice"></slot>
    </div>
</template>

<style lang="less" type="text/less">
.d-none {
    display: none;
}
@media (min-width: 768px) {
    .md\:table-row {
        display: table-row;
    }
}
.tooltip-card {
    visibility: hidden;
    background-color: #ff00a7;
    color: white;
    position: absolute;
    z-index: 1;
    transform: translateX(-50%);
    left: 50%;
    bottom: 150%;
    border-radius: 12px;
    opacity: 0;
    transition: opacity 0.3s;
    width: 480px;
    padding: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    text-align: left;
    &:after {
        content: '';
        position: absolute;
        bottom: -20px;
        left: 50%;
        transform: translateX(-50%);
        border-width: 20px 14px 0;
        border-style: solid;
        border-color: #ff00a7 transparent transparent;
    }
}
.tooltip-container{
    position: relative;
}
.tooltip-container:hover .tooltip-card{
    visibility: visible;
    opacity: 1;
}
.PreviewableInput__preview button{
    color: #ff00a7;
}
</style>

<script type="text/babel">
import Amount from 'dashboard-js/components/utilities/Amount'
import FormItem from 'dashboard-js/components/utilities/FormItem'
import PreviewableInput from 'dashboard-js/components/utilities/PreviewableInput'

export default {
    components: { FormItem, Amount, PreviewableInput },

    props: ['form', 'alwaysEdit', 'campaignName', 'brandName'],

    data() {
        return {
            changingPrice: false,
            maxPrice: 10000000000, // 10 billion
        }
    },

    computed: {
        influencerPayoutFeePercent() {
            return parseFloat(Spark.config.billing.influencer_payout_fee_percent)
        },
        influencerProfit() {
            return this.amount(
                parseInt(this.form.influencer_cost.amount)
            )
        },
        influencerPayout() {
            return this.amount(
                Math.round(this.influencerProfit.amount)
            )
        },
        posts() {
            return this.form.posts
        },
    },
    methods: {
        amount(amount) {
            return Object.assign({}, this.form.influencer_cost, { amount })
        },
    },
}
</script>
